// import HomeIcon from '@mui/icons-material/Home';
import CategoryIcon from '@mui/icons-material/Category';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
// import SupportAgentIcon from '@mui/icons-material/SupportAgent';
// import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
// import QrCodeIcon from '@mui/icons-material/QrCode';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
// import  AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
// import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import HistoryIcon from '@mui/icons-material/History';
import PaidIcon from '@mui/icons-material/Paid';
import SettingsIcon from '@mui/icons-material/Settings';
// import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
// import TvIcon from '@mui/icons-material/Tv';

export const drawerRoute = [
    // Disabled for this client.
    //     {
    //         id: 24,
    //         name: 'Order traking',
    //         path: '/OrderTracking',
    //         icon: <ViewKanbanIcon />,
    //         roles: [1, 2, 5],
    //     },
    // Disabled for this client.
    //     {
    //         id: 25,
    //         name: 'Customer Dashboard',
    //         path: '/CustomerDashboard',
    //         icon: <TvIcon />,
    //         roles: [1, 2, 5],
    //     },
    // {
    //     id: 1,
    //     name: 'Home',
    //     path: '/',
    //     icon: <HomeIcon />
    // },
    {
        id: 2,
        name: 'Billing',
        path: '/billing',
        icon: <ReceiptIcon />,
        roles: [1, 2],
    },
    {
        id: 26,
        name: 'Bill History',
        path: '/BillHistory',
        icon: <HistoryIcon />,
        roles: [1],
    },
    {
        id: 23,
        name: 'Expenses',
        path: '/Expenses',
        icon: <PaidIcon />,
        roles: [1, 2],
    },
    // {
    //     id: 22,
    //     name: 'Reservations',
    //     path: '/Reservations',
    //     icon: <AutoStoriesIcon />
    // },
    {
        id: 3,
        name: 'Supplier Management',
        path: '/SupplierManagement',
        icon: <PersonAddIcon />,
        roles: [1],
    },
    {
        id: 4,
        name: 'Category Management',
        path: '/CategoryManagement',
        icon: <CategoryIcon />,
        roles: [1],
    },
    // {
    //     id: 5,
    //     name: 'Pet Management',
    //     path: '/PetManagement',
    //     icon: <SupportAgentIcon />
    // },
    {
        id: 6,
        name: 'User Management',
        path: '/UserManagement',
        icon: <AdminPanelSettingsIcon />,
        roles: [1],
    },
    {
        id: 7,
        name: 'Item Management',
        path: '/ItemManagement',
        icon: <CategoryIcon />,
        roles: [1],
    },
    // {
    //     id: 8,
    //     name: 'Doctor Management',
    //     path: '/DoctorManagement',
    //     icon: <LocalHospitalIcon />
    // },
    // Disabled for this client.
    //     {
    //         id: 9,
    //         name: 'Barcode Genaration',
    //         path: '/barcodeGen',
    //         icon: <QrCodeIcon />
    //     },
    {
        id: 9,
        name: 'GRN',
        path: '/grn',
        icon: <EventAvailableIcon />,
        roles: [1, 2],
    },
    // {
    //     id: 12,
    //     name: 'To Main Store',
    //     path: '/StockReturn',
    //         icon: <AssignmentReturnIcon />
    // },
    {
        id: 11,
        name: 'Inventory',
        path: '/StockAllocation',
        icon: <Inventory2Icon />,
        roles: [1],
    },
    {
        id: 10,
        name: 'Reports',
        path: '/ReportModule',
        icon: <TextSnippetIcon />,
        roles: [1],
    },

    { id: 27, name: 'Settings', path: '/Settings', icon: <SettingsIcon />, roles: [1] },
]
